<style type="text/css">

</style>
<template>
  <div class="new_terms" >

    <form class="forms-sample" style="border-radius: 10px; border: 1px solid gainsboro" :key="this.$route.params.terms">
      <h5 class=" sub-title mb-3 font-weight-bold color-default">{{ formHeader }}</h5>
      <!-- body input -->
      <div class="form-group">
        <label class="label-form" for="describtion">Body<span style="color: red;">*</span>:</label>
        <div class="text_editor">
          <tiny-mce-editor :vModelName.sync="termsForm.body"></tiny-mce-editor><br>
        </div>
      </div>

      <div class="text-right">
        <button class="btn btn-primary" @click.prevent="save">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import 'jodit/build/jodit.min.css';
  import JoditVue from 'jodit-vue';
  import TinymceEditor from '../../views/partials/tiny_mce_editor';
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      Multiselect,
      JoditVue,
      'tiny-mce-editor': TinymceEditor,
    },


    data: function () {
      return {
        formHeader: '',
        termsForm: {
          remove_image: false
        },

        buttons: [
          'bold', 'strikethrough', 'underline', 'italic', '|',
          'ul', 'ol', '|',
          'image', 'table', 'link', '|',
          'outdent', 'indent', '|',
          'align', 'undo', 'redo', '|',
          'hr', 'symbol', 'fullsize'
        ],
        config: {
          "uploader": {
            "insertImageAsBase64URI": true
          }
        }
      };
    },


    computed: {
      terms: function () {
        return this.$store.getters['termsandconditions/terms'];
      }
    },
    created: function () {
      // new form
      if (typeof this.$route.params.terms === 'undefined') {
        this.formHeader = 'New Terms';
        this.termsForm = null;
        this.termsForm = {
          body: '',
        };
        return;
      }
    },

    methods: {
      save() {
        if (this.termsForm.body == '') {
          this.$store.dispatch('message/update', {
            title: 'Alert',
            body: ` Please write something before preciding.`,
            class: 'warning',
            confirm: false
          }, { root: true });

          return;
        }
        if (typeof this.$route.params.terms === 'undefined') {
          this.createTerms(this.termsForm);
          return;
        }
      },

      // create new Terms
      createTerms(terms) {
        this.$store.dispatch('termsandconditions/createTerm', terms)
          .then((response) => {
            // send successful message
            this.$store.dispatch('message/update', {
              title: 'Terms & Conditions',
              body: `Terms and conditions has been saved successfully`,
              class: 'success',
              confirm: false
            }, { root: true });
            this.$router.push('/term&conditions/' + response.data.term.id);
          })
          .catch((error) => {
            let response = error.response;

            // send error message
            this.$store.dispatch('message/update', {
              title: '',
              body: response,
              itemsErrors: response.errors,
              class: 'danger',
              confirm: false
            }, { root: true });
          });
      },



    }
  }
</script>
<style scoped>
  .new_terms{
    margin-top: -89px !important;
  }
    
</style>